import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useGuideConfig } from '@ignitesales/neuro-application';
import { LayoutRenderer } from '@ignitesales/neuro-application/src/neuro-guide/components/QuestionGroups/layouts';

/**
 * LayoutBlockContainer
 * A flexible slot container that renders configured blocks (e.g., custom headers, footers, sidebars).
 */
const LayoutBlockContainer = ({ 
    page = '',
    position = '',
    minHeight
}) => {
    const { layouts = [] } = useGuideConfig();
    
    if (!position || !page) {
         return null;
    }

    // Find the block matching the specified page and position
    const block = layouts?.find(l => 
        l.layoutType === 'block' && 
        l.block?.page === page && 
        l.block?.position === position
    );
    
    if (!block) {
         return null;
    }

    const wrapperClass = classnames(
        'LayoutBlockContainer',
        `LayoutBlockContainer--${position}`
    );
    
    const wrapperStyle = minHeight ? { minHeight: `${minHeight}px` } : {};
    
    // Create action object for LayoutRenderer
    const action = useMemo(() => ({
        layoutId: block.id
    }), [block.id]);
    
    return (
        <div className={wrapperClass} style={wrapperStyle}>
            <LayoutRenderer action={action} layout={block} minHeight={minHeight} />
        </div>
    );
};

LayoutBlockContainer.propTypes = {
    page: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    minHeight: PropTypes.number
};

export default LayoutBlockContainer;
